export const AppFeature = (value: string) => {
  localStorage.setItem('showFeatures', value);
};

export const isFeature = () => {
  return localStorage.getItem('showFeatures') === 'true';
};
